import Utils from '../../utils/util';

function sortLayers(temp: FreeObjMap[]): FreeObjMap[] {
    let sortY: FreeObjMap[] = Utils.quickSortByKey(temp, 'posY').reverse();
    let sameY: FreeObjMap[] = [];

    for (let i = 0; i < sortY.length; i++) {
        if (sortY[i - 1] && sortY[i - 1].posY === sortY[i].posY) {
            if (sameY.length === 0) {
                sameY.push(sortY[i - 1]);
            }
            sameY.push(sortY[i]);
            continue;
        }

        if (sameY.length !== 0) {
            let sortX: FreeObjMap[] = Utils.quickSortByKey(sameY, 'posX');
            let cur: number = i - 1;

            for (let j = sortX.length - 1; j >= 0; j--) {
                sortY[cur] = sortX[j];
                cur--;
            }
        }

        sameY = [];
    }

    if (sameY.length !== 0) {
        let sortX: FreeObjMap[] = Utils.quickSortByKey(sameY, 'posX');
        let cur: number = sortY.length - 1;

        for (let j = sortX.length - 1; j >= 0; j--) {
            sortY[cur] = sortX[j];
            cur--;
        }
        sameY = [];
    }

    return sortY;
}

export {
    sortLayers
};
